import React from "react";
import Joi from "joi";
import "./styles.scss";

interface IErrorMessageProps {
  errors: Joi.ValidationError | string | null;
}

export const ErrorMessage: React.FC<IErrorMessageProps> = ({ errors }) => {
  if (!errors) {
    return null;
  }

  if (typeof errors === "string") {
    return <div className="heroff2-validation-msg">{errors}</div>;
  }

  const errorsArray = errors?.details.map((err) => err.message);
  let message = "";

  if (errorsArray) {
    if (errorsArray.length > 1) {
      const lastElement = errorsArray.pop();
      message = `${errorsArray.join(", ")} and ${lastElement}.`;
    } else {
      message = `${errorsArray[0]}.`;
    }
  }

  return <div className="heroff2-validation-msg">{message}</div>;
};
